import { InjectableClass } from '@fino/lib-injection';

export class TicketsChartService extends InjectableClass {
  constructor(TicketTableDateFilter) {
    'ngInject';
    super({ TicketTableDateFilter });
  }

  /*
   * Builds the data for the chart based on tickets
   */
  getChartData(tickets, type, filterTypes, states) {
    // No tickets -> no chart data
    if (!tickets) {
      return;
    }

    // Set the groupBy attribute and filter options for the
    // different filter types
    if (type === filterTypes.dates) {
      states = this.TicketTableDateFilter;
    }

    let maxValue = 0;
    const values = Object.keys(states).map(key => {
      let value = tickets[key] || 0;

      // Check for aggregated states to combine their values
      if (states[key].aggregatedStates) {
        states[key].aggregatedStates.map(state => {
          value += tickets[state] || 0;
        });
      }

      maxValue = Math.max(maxValue, value);

      return {
        key,
        value,
        className: states[key].className
      };
    }).filter(v => v.value > 0);

    // Round maxValue to the next tenth
    maxValue = (Math.floor((maxValue) / 10) + 1) * 10;

    return {
      maxValue,
      values
    };
  }
}
